import { useContext } from "react";

import {
  TenantContextType,
  TenantContext,
} from "../contexts/Tenant/TenantContext";

export const useTenants = (): TenantContextType => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error("useTenants must be used within a Provider");
  }
  return context;
};
